import { Link } from "react-router-dom";

const BigCTA = (props) => {
    return (
        <Link to={props.linkTo} >
            <div className="flex flex-col items-center">
                <img alt="icon" className="max-w-[20vw] md:max-w-[15vw]" src={props.imageSrc} />
                <p className="mt-4 font-regular text-[1.1rem] md:text-[1.3rem] text-center">{props.text}</p>
            </div>
        </Link>
    );
}

export default BigCTA;